import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function PencilIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="PencilIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <g>
                <path
                    fill="#27292b"
                    d="M31.33,32h-11.33c-.7,0-1.26-.56-1.26-1.26s.56-1.26,1.26-1.26h11.33c.7,0,1.26.56,1.26,1.26s-.56,1.26-1.26,1.26Z"
                />
                <path
                    fill="#27292b"
                    d="M9.3,32c-.31,0-.62-.08-.9-.23-.44-.24-.77-.64-.91-1.13-.1-.34-.1-.71,0-1.06l1.05-3.61c.18-.61.51-1.17.96-1.61l15.1-15.1c.71-.76,1.67-1.2,2.71-1.24,1.04-.05,2.05.33,2.82,1.04.77.71,1.22,1.68,1.26,2.73s-.33,2.05-1.04,2.82c-.07.07-.14.15-.22.22l-15.08,15.09c-.45.45-1.01.78-1.62.96l-3.61,1.05c-.18.05-.35.08-.53.08ZM27.47,10.52s-.04,0-.06,0c-.38.01-.73.18-.98.45l-15.12,15.12c-.15.15-.26.33-.32.54l-.73,2.51,2.51-.73c.2-.06.39-.17.54-.32l15.12-15.12c.26-.28.39-.64.37-1.01s-.18-.73-.45-.98c-.26-.24-.6-.37-.96-.37Z"
                />
                <path
                    fill="#27292b"
                    d="M27.55,16.89c-.32,0-.64-.12-.89-.37l-3.78-3.78c-.49-.49-.49-1.29,0-1.78s1.29-.49,1.78,0l3.78,3.78c.49.49.49,1.29,0,1.78-.25.25-.57.37-.89.37Z"
                />
            </g>
        </SvgIcon>
    );
}
